import { closeListBulkEditSession } from 'ducks/listBulkEdit'
import { getBulkEditDefinition } from 'elements/listBulkEdit/bulkEditRegistry'
import { ListBulkEditDialog } from 'elements/listBulkEdit/ListBulkEditDialog'
import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import type { RootState } from 'types/state'

export const ListBulkEditGlobalHost = () => {
  const dispatch = useDispatch()
  const session = useSelector((s: RootState) => s.listBulkEdit.session)
  const definition = session ? getBulkEditDefinition(session.resource) : undefined
  const onClose = useCallback(() => dispatch(closeListBulkEditSession()), [dispatch])

  if (!session || !definition) {
    return null
  }

  return <ListBulkEditDialog open={true} session={session} onClose={onClose} definition={definition} />
}
